import React, { useContext } from "react";
import { useHistory } from "react-router";
import { AppContext } from "../context/AppContext";
import { RouterParams } from "../router/RouterParams";

import { get as providerGet, prepare as providerPrepare } from "../api/ProviderSECfdiApi";
import { get, prepare } from "../api/TenantSECfdiApi";
import { Cfdi } from "../model/Cfdi";
import { PrepareCfdiRequest } from "../model/CfdiSe";
import CfdiIssuedPrepareAnyForm, { PrepareResponses } from "./CfdiIssuedPrepareAnyForm";

export default function CfdiIssuedPrepareForm({ match }: RouterParams) {
    const context = useContext(AppContext);
    const tenantId = context.session?.tenant?.id ?? "-";
    const providerId = context.session?.provider?.id;
    const cfdiId = match.params.cfdiId;
    const history = useHistory();

    const promiseGet = () => {
        if (providerId) {
            return providerGet(tenantId, providerId, cfdiId);
        }
        return get(tenantId, cfdiId);
    };

    const promisePrepare = (prepareRequest: PrepareCfdiRequest) => {
        if (providerId) {
            return providerPrepare(tenantId, providerId, cfdiId, prepareRequest);
        }
        return prepare(tenantId, cfdiId, prepareRequest);
    };

    const handleResponse = (response: Cfdi) => {
        history.push(`/cfdis/se/${response.id}/details`);
    };

    return (
        <CfdiIssuedPrepareAnyForm
            match={match}
            promiseCfdi={promiseGet}
            promisePrepare={promisePrepare}
            onSubmitSuccess={(response: PrepareResponses) => {
                handleResponse(response as Cfdi);
            }}
            onCancel={() => {
                history.goBack();
            }}
        />
    );
}
